// extracted by mini-css-extract-plugin
export default {"table":"feelingMeterNotesTable__table___2Lno2","noNotes":"feelingMeterNotesTable__noNotes___q6Z1Q"};